import React from 'react';

// Slim, always-visible "call us" bar pinned to the bottom on mobile only.
// Tap dials the office. Calls are the firm's primary conversion, and this lets
// visitors call from any page without navigating to the contact page.
// The global tel: click listener (analytics.ts) tracks taps as `click_call`.
const MobileCallBar: React.FC = () => (
  <a
    href="tel:+4722535322"
    aria-label="Ring Advokatfirmaet Bruland på 22 53 53 22"
    className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-2 bg-primary py-3.5 font-semibold text-white shadow-[0_-2px_12px_rgba(0,0,0,0.18)]"
  >
    <svg className="w-5 h-5 text-accent-light" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
    </svg>
    Ring oss: 22 53 53 22
  </a>
);

export default MobileCallBar;
